export default {
  remove: 'Remove',
  result: 'Result',
  retry: 'Retry',
  risk: 'Risk',
  risks: 'Risks',
  revoke: 'Revoke'
}
